import React, { useState } from "react";
import NavLogo from "../assets/banner/nav-logo.webp";
import World from "../assets/world.webp";
import { FiMenu } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import OutsideClickHandler from "react-outside-click-handler";
import languageStorage from "../lang/findLanguage";
import languages from "../lang/languages";
import Navbar from "react-bootstrap/Navbar";

export default function NavbarComp() {
  const [isOpen, setIsOpen] = useState(false);
  const [menuFixed, setMenuFixed] = useState(false);
  const [activeLangauge, setActiveLanguage] = useState(false);
  const [language] = useState(languages);

  const openHandle = () => setIsOpen(true);
  const closeHandle = () => setIsOpen(false);

  window.addEventListener("scroll", () => {
    if (window.scrollY > 200) {
      setMenuFixed(true);
    } else {
      setMenuFixed(false);
    }
  });

  function changeUrl(languageText, languageUrl, languagePush) {
    localStorage.setItem("lang", languageText);
    let url = window.location.href.replace(window.location.origin + "/", "");

    if (url.includes("#")) {
      let newUrl = url.split("#")[0];

      if (newUrl === `${languageUrl}`) {
        // history.push(`/${languagePush}`);
        window.location.href = `/${languagePush}`;
      }
    } else {
      if (url === `${languageUrl}`) {
        // history.push(`/${languagePush}`);
        window.location.href = `/${languagePush}`;
      }
    }
  }

  function closeMenu() {
    setIsOpen(false);
  }

  return (
    <Navbar className={`header-nav d-flex align-items-center justify-content-between ${menuFixed ? "active" : ""}`}>
      <Link to="/" className="logo-brand">
        <img src={NavLogo} alt="Logo" className="img-fluid" width="120" height="30" />
      </Link>
      <div className="menu d-flex align-items-center">
        <div className="menuItems">
          <ul className={`d-flex align-items-center ${isOpen ? "" : "hide-menu"}`}>
            <li onClick={closeMenu}>
              <a href="https://app.bandwitt.com/" target="_blank" rel="noreferrer">
                {languageStorage() === "tr" ? language[0].sections[0].keys[0].k0001 : language[1].sections[0].keys[0].k0001}
              </a>
            </li>
            <li onClick={closeMenu}>
              <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[0].k0001 : language[1].sections[11].keys[0].k0001}`}>
                {languageStorage() === "tr" ? language[0].sections[0].keys[1].k0002 : language[1].sections[0].keys[1].k0002}
              </a>
            </li>
            <li onClick={closeMenu}>
              <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[1].k0002 : language[1].sections[11].keys[1].k0002}`}>
                {languageStorage() === "tr" ? language[0].sections[0].keys[2].k0003 : language[1].sections[0].keys[2].k0003}
              </a>
            </li>
            <li onClick={closeMenu}>
              <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[2].k0003 : language[1].sections[11].keys[2].k0003}`}>
                {languageStorage() === "tr" ? language[0].sections[0].keys[3].k0004 : language[1].sections[0].keys[3].k0004}
              </a>
            </li>
            <li onClick={closeMenu}>
              <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[3].k0004 : language[1].sections[11].keys[3].k0004}`}>
                {languageStorage() === "tr" ? language[0].sections[0].keys[4].k0005 : language[1].sections[0].keys[4].k0005}
              </a>
            </li>
            <li onClick={closeMenu}>
              <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[4].k0005 : language[1].sections[11].keys[4].k0005}`}>
                {languageStorage() === "tr" ? language[0].sections[0].keys[5].k0006 : language[1].sections[0].keys[5].k0006}
              </a>
            </li>
            <li onClick={closeMenu}>
              <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[5].k0006 : language[1].sections[11].keys[5].k0006}`}>
                {languageStorage() === "tr" ? language[0].sections[0].keys[6].k0007 : language[1].sections[0].keys[6].k0007}
              </a>
            </li>
            <li className="language">
              <OutsideClickHandler onOutsideClick={() => setActiveLanguage(false)}>
                <p className="d-flex align-items-center" onClick={() => setActiveLanguage(!activeLangauge)}>
                  <img src={World} alt="" width="20" height="20" />
                  <span>{languageStorage() === "en" ? "EN" : "TR"}</span>
                </p>
              </OutsideClickHandler>
              <div className={`languages ${activeLangauge ? "" : "hide"}`} onClick={() => setActiveLanguage(false)}>
                <Link to="#" onClick={() => (languageStorage() === "en" ? changeUrl("tr", "en", "") : changeUrl("en", "", "en"))}>
                  {languageStorage() === "en" ? "TR" : "EN"}
                </Link>
              </div>
            </li>
          </ul>
        </div>

        <FiMenu className={isOpen ? "hide-icon" : ""} size="32" color="#DF500E" onClick={() => openHandle()} />
        <MdClose className={isOpen ? "" : "hide-icon"} size="32" color="#DF500E" onClick={() => closeHandle()} />
      </div>
    </Navbar>
  );
}
